import { Link } from "react-router-dom";
import Container from "./Container";
import useUserStore from "../../stores/user";
import { E_USER_TIER } from "../../constants/common";

const Footer = () => {
  const { user } = useUserStore();
  // Determine which Line contact to show
  const isNarinOnline =
    user &&
    user.userTierId >= E_USER_TIER.GROCERY &&
    user.userTierId <= E_USER_TIER.PHARMACY;
  const lineLink = isNarinOnline
    ? "https://line.me/ti/p/~@narinonline"
    : "https://line.me/ti/p/~@narinch";
  const lineText = isNarinOnline ? "@narinonline" : "@narinch";

  return (
    <div className="h-[248px] bg-[#5815B7] min-w-[1440px] text-white">
      <Container>
        <div className="h-[210px] grid grid-cols-4">
          <div className="flex flex-col justify-center items-center">
            <img src="/logo.png" width={90} height={90} />
            <div>บริษัท นรินทร์เภสัช จำกัด</div>
            <div>NARINONLINE</div>
          </div>
          <div className="flex flex-col justify-center gap-2">
            <div className="text-secondary font-semibold">ช่องทางการติดต่อ</div>
            <div>
              <div>291 ถนนยุติธรรม ตำบลในเมือง </div>
              <div>อำเภอเมือง จังหวัดชัยภูมิ </div>
              <div>36000</div>
            </div>
            <div>โทร. 088-886-8628</div>
          </div>
          <div className="flex flex-col justify-center gap-2">
            <div className="text-secondary font-semibold">เปิดบริการ</div>
            <div>จันทร์ - เสาร์ เวลา 08:00 น. - 18:00 น. </div>
            <div className="text-secondary font-semibold">Social Media</div>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/narinbhaesaj"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex gap-2">
                  <img src="/facebook-icon.png" height={20} width={24} />
                  <div>narinbhaesaj</div>
                </div>
              </a>
              <a href={lineLink} target="_blank" rel="noopener noreferrer">
                <div className="flex gap-2">
                  <img src="/line-icon.png" height={20} width={24} />
                  <div>{lineText}</div>
                </div>
              </a>
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <div className="grid grid-cols-2">
              <div className="text-secondary font-semibold col-span-2">
                ข้อมูลร้านยา
              </div>
              <div>
                <Link to="/why-2-buy">
                  <div className="hover:text-secondary">ทำไมต้องซื้อกับเรา</div>
                </Link>
                <Link to="/return-policy">
                  <div className="hover:text-secondary">
                    เงื่อนไขการเปลี่ยนคืนสินค้า
                  </div>
                </Link>
                {/* <div>วิธีการสั่งซื้ออัตรา</div> */}
              </div>
              {/* <div>
                <div>ค่าจัดส่ง </div>
                <div>ติชม/ร้องเรียน </div>
              </div> */}
            </div>
          </div>
        </div>
      </Container>
      <div className="h-[38px] bg-primary-500 flex items-center justify-center text-base">
        COPYRIGHT © 2025 NARINONLINE
      </div>
    </div>
  );
};
export default Footer;
